import { c as _c } from "react/compiler-runtime";
import { SearchInput } from '@onefootprint/ui';
import { type ReactNode, useState } from 'react';
import List from './list';
type SearchListProps<T> = {
  items: T[];
  getSearchText: (item: T) => string;
  renderItem: (item: T) => ReactNode;
  placeholder: string;
  emptyText: string;
};
const SearchList = t0 => {
  const $ = _c(14);
  const {
    items,
    getSearchText,
    renderItem,
    placeholder,
    emptyText
  } = t0;
  const [query, setQuery] = useState("");
  let t1;
  if ($[0] !== getSearchText || $[1] !== items || $[2] !== query) {
    const needle = query.trim().toLowerCase();
    t1 = needle ? items.filter(item => getSearchText(item).toLowerCase().includes(needle)) : items;
    $[0] = getSearchText;
    $[1] = items;
    $[2] = query;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const matches = t1;
  let t2;
  if ($[4] !== placeholder || $[5] !== query) {
    t2 = <SearchInput size="compact" placeholder={placeholder} value={query} onChangeText={setQuery} />;
    $[4] = placeholder;
    $[5] = query;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== emptyText || $[8] !== matches || $[9] !== renderItem) {
    t3 = matches.length ? <List>{matches.map(renderItem)}</List> : <p className="text-caption-1 text-tertiary">{emptyText}</p>;
    $[7] = emptyText;
    $[8] = matches;
    $[9] = renderItem;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex flex-col gap-3">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default SearchList;